import { useMemo } from 'react';

import { useGetUserQuery } from 'src/common/slices';
import { Campaign } from 'src/common/interfaces/campaigns';
import { useGetSubscriptionPricingQuery } from 'src/features/pricing/pricing.slice';

import { priceHikeMap } from './beat-the-price-hike.constants';

export const useCampaignCta = (campaign: Campaign | null): [string, string] => {
  const { data: userDataResponse } = useGetUserQuery();

  return useMemo(() => {
    if (userDataResponse?.data?.user?.isPremium) {
      return ['Switch to annual', '/manage-account/subscription'];
    }
    const isDiscountAvailable = campaign?.amount && campaign?.amount > 0;
    const label = isDiscountAvailable ? `Subscribe now & save ${campaign.amount}%` : 'Subscribe Now';

    return [label, '/why-subscribe'];
  }, [userDataResponse, campaign]);
};

export const useMonthlyPlanHikedPrice = () => {
  const { data: response } = useGetSubscriptionPricingQuery(false);

  const pricing = useMemo((): { hikedPrice: string; originalPrice: string; symbol: string } | undefined => {
    const plan = response?.data?.monthlyPlan;
    if (!plan) return undefined;

    const hikedPrice = priceHikeMap.get(plan.planId);
    if (!hikedPrice) return undefined;

    return {
      hikedPrice: hikedPrice.toFixed(2),
      originalPrice: plan.price.toFixed(2),
      symbol: plan.symbol,
    };
  }, [response?.data]);

  return pricing;
};
